module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/like-1cbbf4f194b14170a624b7a079e0d092.svg";